import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "item"]

  connect() {
    // Since Turbo is disabled, we just need to handle initial page loads
    // Use multiple scheduling approaches to ensure it works reliably
    this.scheduleScrollToActive()

    // Also listen for DOMContentLoaded in case we missed it
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        this.scheduleScrollToActive()
      })
    }
  }

  scheduleScrollToActive() {
    // Use multiple timing strategies to ensure reliable scrolling
    // Immediate attempt
    this.scrollToActiveItem()

    // Short delay for any async rendering
    setTimeout(() => {
      this.scrollToActiveItem()
    }, 100)

    // Longer delay as final fallback
    setTimeout(() => {
      this.scrollToActiveItem()
    }, 500)
  }

  scrollToActiveItem() {
    const activeItem = this.itemTargets.find(item =>
      item.classList.contains("active-sidebar-item")
    )

    if (activeItem && this.hasContainerTarget) {
      // Get the scrollable container (sidebar)
      const container = this.containerTarget

      // Calculate the position to scroll to center the active item
      const containerRect = container.getBoundingClientRect()
      const itemRect = activeItem.getBoundingClientRect()

      // Calculate the scroll position to center the item in the container
      const targetScrollTop = container.scrollTop +
        (itemRect.top - containerRect.top) -
        (containerRect.height / 2) +
        (itemRect.height / 2)

      // Smooth scroll within the container only
      container.scrollTo({
        top: targetScrollTop,
        behavior: "smooth"
      })
    }
  }
}